import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Spinner, Switch, useOverlayContext } from 'seagull';
import { useStoreActions } from '~/contexts';
import styles from '../BillingControl.module.scss';
export default function CreditSwitch(props) {
    const { chargeId, agreementId, isPaused, disabled, tooltipTitle, testId, onRefresh } = props;
    const [isResumed, setIsResumed] = useState(!isPaused);
    const [loading, setLoading] = useState(false);
    const overlayContext = useOverlayContext();
    const { api } = useStoreActions();
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.switch,
        children: [
            loading && /*#__PURE__*/ _jsx(Spinner, {
                size: 24
            }),
            /*#__PURE__*/ _jsx(Switch, {
                value: chargeId,
                checked: isResumed,
                disabled: disabled || loading,
                testId: testId,
                tooltip: tooltipTitle ? {
                    placement: 'top',
                    title: /*#__PURE__*/ _jsx("div", {
                        "data-testid": testId && "".concat(testId, "-tooltip"),
                        children: tooltipTitle
                    })
                } : undefined,
                onChange: async (e)=>{
                    const { checked, value } = e.target;
                    try {
                        setLoading(true);
                        if (checked) {
                            await api.charge.resumeCredit(agreementId, value);
                        } else {
                            await api.charge.pauseCredit(agreementId, value);
                        }
                        await onRefresh({
                            silent: true
                        });
                        setIsResumed(checked);
                    } catch (error) {
                        overlayContext.showErrorToast("Failed to ".concat(checked ? 'resume' : 'pause', " credit"), 'pause-credit-error-toast');
                    } finally{
                        setLoading(false);
                    }
                }
            })
        ]
    });
}
